import React from 'react';
import './ResourceTagsModal.scss';
import {
  Box, Modal
} from '@mui/material';
import ResourceTagsList from '../../pages/resource/resourceTags/ResourceTagsList';
import { ResourceTagContext } from '../../features/resourceTags/resourceTags.model';

interface ReactTagsModalProps {
  open: boolean;
  onClose: () => void;
  tagContext?: ResourceTagContext;
}

const ResourceTagsModal: React.FC<ReactTagsModalProps> = ({ open, onClose, tagContext }) => {

  return (
    <Modal
      id="resource-tags-modal"
      open={open}
      onClose={onClose}
    >
      <Box className="modal-content card-background flex_col_jcenter">
        <ResourceTagsList
          inModal={true}
          modalClose={onClose}
          tagContext={tagContext}
        />
      </Box>
    </Modal>
  );
};


export default ResourceTagsModal;
